import header from './header'
import button from './button'
import dialog from './dialog'
import input from './input'
import tab from './tab'
import dateSelector from '../comps/date-selector'
import tile from '../comps/tile'
import title from '../comps/title-text'
import order from '../comps/order'
import qrCode from '../comps/qr-code'
import stamp from '../comps/stamp'
import message from '../comps/message'
import period from '../comps/period'
import topTab from '../comps/top-tab'
import radio from '../comps/radio'
import infoItem from '../comps/info-item'
import cells from './cells'
import itemCell from './item-cell'
import itemTotalPrice from './item-total-price'
import itemStaticsTitle from './item-statics-title'
import itemStaticsDish from './item-statics-dish'
import itemAlignTextCell from './item-align-text-cell'
import personalCard from './personal-info-card'
import charge from './charge'
import textButton from './text-button'
import itemDoubleLine from './item-double-line'
import banner from './banner'
import toast from './toast'
import loading from './loading'
import noData from './no-data'
import itemCustomRight from './item-custom-right'
import dialogSelector from './dialog-selector'
import dialogCustom from './dialog-custom'
import attention from './attention'
import qrcodeTip from './qrcode-tip'
import foxconn from './foxconn'
export default {
  loading,
  toast,
  banner,
  'foxconn': foxconn,
  'qrcode-tip': qrcodeTip,
  'no-data': noData,
  'text-button': textButton,
  charge,
  'item-double-line': itemDoubleLine,
  'item-statics-dish': itemStaticsDish,
  'item-statics-title': itemStaticsTitle,
  'item-total-price': itemTotalPrice,
  'item-cell': itemCell,
  cells,
  header,
  button,
  stamp,
  'date-selector': dateSelector,
  'qr-code': qrCode,
  tab,
  'top-tab': topTab,
  'info-item': infoItem,
  'item-align-text-cell': itemAlignTextCell,
  tile,
  dialog,
  'personal-info-card': personalCard,
  input,
  'title-text': title,
  order,
  message,
  period,
  radio,
  'item-custom-right': itemCustomRight,
  'dialog-selector': dialogSelector,
  'dialog-custom': dialogCustom,
  'attention': attention
}


// WEBPACK FOOTER //
// ./src/comps/index.js